module.exports = __webpack_public_path__ + "img/ES-J-13.0f0054e4.svg";